var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "i-form" },
    [
      _c(
        "Form",
        {
          ref: "form",
          style: _vm.formWidth,
          attrs: {
            model: _vm.model,
            rules: _vm.rules,
            inline: _vm.inline,
            "label-width": _vm.labelWidth,
            "label-position": _vm.labelPosition,
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.handleSubmit("form")
            },
          },
        },
        [
          _vm._t("head"),
          _c(
            "Row",
            _vm._l(_vm.elem, function (item, index) {
              return _c(
                "Col",
                { key: index, attrs: { span: _vm.splitModel } },
                [
                  _c(
                    "FormItem",
                    {
                      style: item.width,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "label-width": item.labelWidth,
                      },
                    },
                    [
                      !item.element
                        ? _c("Input", {
                            style: item.elemWidth,
                            attrs: {
                              type: item.type,
                              placeholder: item.placeholder,
                              autocomplete:
                                item.type == "password" ? "new-password" : "",
                              size: item.size,
                              disabled: item.disabled,
                              readonly: item.readonly,
                              icon: item.icon,
                              prefix: item.prefix,
                              suffix: item.suffix,
                              number: item.number,
                              rows: item.rows,
                              autosize: item.autosize,
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "textarea"
                        ? _c("VxeTextarea", {
                            style: item.elemWidth,
                            attrs: {
                              type: item.type,
                              placeholder: item.placeholder,
                              size: item.size,
                              disabled: item.disabled,
                              readonly: item.readonly,
                              icon: item.icon,
                              prefix: item.prefix,
                              suffix: item.suffix,
                              number: item.number,
                              rows: item.rows,
                              autosize: item.autosize,
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "number"
                        ? _c("InputNumber", {
                            style: item.elemWidth,
                            attrs: {
                              max: item.max,
                              min: item.min,
                              step: item.step,
                              placeholder: item.placeholder,
                              size: item.size,
                              disabled: item.disabled,
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "select"
                        ? _c(
                            "Select",
                            {
                              style: item.elemWidth,
                              attrs: {
                                placeholder: item.placeholder,
                                size: item.size,
                                disabled: item.disabled,
                                filterable: item.filterable,
                                multiple: item.multiple,
                              },
                              on: {
                                "on-change": (value) =>
                                  _vm.$emit(
                                    `on-${item.events}`,
                                    value,
                                    item.prop
                                  ),
                              },
                              model: {
                                value: _vm.model[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, item.prop, $$v)
                                },
                                expression: "model[item.prop]",
                              },
                            },
                            _vm._l(item.option, function (opt, index) {
                              return _c(
                                "Option",
                                {
                                  key: index,
                                  attrs: {
                                    value: opt.value,
                                    disabled: opt.disabled,
                                  },
                                },
                                [_vm._v(_vm._s(opt.label))]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      item.element === "cascader"
                        ? _c("el-cascader", {
                            attrs: {
                              size: item.size,
                              placeholder: item.placeholder,
                              options: item.option,
                              props: { multiple: true },
                              clearable: "",
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "date"
                        ? _c("DatePicker", {
                            style: item.elemWidth,
                            attrs: {
                              type: item.type,
                              options: item.options,
                              format: item.format,
                              placeholder: item.placeholder,
                              size: item.size,
                              disabled: item.disabled,
                            },
                            on: {
                              "on-change": (value) =>
                                _vm.$emit(`on-${item.events}`, value),
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "time"
                        ? _c("TimePicker", {
                            style: item.elemWidth,
                            attrs: {
                              type: item.type,
                              format: item.format,
                              placeholder: item.placeholder,
                              size: item.size,
                              disabled: item.disabled,
                            },
                            model: {
                              value: _vm.model[item.prop],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.prop, $$v)
                              },
                              expression: "model[item.prop]",
                            },
                          })
                        : _vm._e(),
                      item.element === "radio"
                        ? _c(
                            "RadioGroup",
                            {
                              attrs: {
                                type: item.type,
                                size: item.size,
                                vertical: item.vertical,
                              },
                              model: {
                                value: _vm.model[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, item.prop, $$v)
                                },
                                expression: "model[item.prop]",
                              },
                            },
                            _vm._l(item.option, function (opt, index) {
                              return _c(
                                "Radio",
                                {
                                  key: index,
                                  attrs: {
                                    label: opt.value,
                                    size: item.size,
                                    disabled: opt.disabled,
                                  },
                                },
                                [_vm._v(_vm._s(opt.label))]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      item.element === "checkbox"
                        ? _c(
                            "CheckboxGroup",
                            {
                              attrs: { size: item.size },
                              model: {
                                value: _vm.model[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, item.prop, $$v)
                                },
                                expression: "model[item.prop]",
                              },
                            },
                            _vm._l(item.option, function (opt, index) {
                              return _c(
                                "Checkbox",
                                {
                                  key: index,
                                  attrs: {
                                    label: opt.value,
                                    size: item.size,
                                    disabled: opt.disabled,
                                  },
                                },
                                [_vm._v(_vm._s(opt.label))]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._t("default"),
          _vm._t("extend"),
          _c(
            "FormItem",
            { attrs: { "label-width": _vm.btnLabelWidth } },
            [
              _vm.submit
                ? _c(
                    "Button",
                    {
                      attrs: {
                        type: _vm.okType,
                        icon: _vm.okIcon,
                        long: _vm.btnLong,
                        loading: _vm.btnLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.submitText))]
                  )
                : _vm._e(),
              _vm.reset
                ? _c(
                    "Button",
                    {
                      staticClass: "button",
                      attrs: {
                        type: _vm.btnType,
                        icon: _vm.btnIcon,
                        long: _vm.btnLong,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.resetText))]
                  )
                : _vm._e(),
              _vm.button
                ? _c(
                    "Button",
                    {
                      staticClass: "button",
                      attrs: {
                        type: _vm.btnType,
                        icon: _vm.btnIcon,
                        long: _vm.btnLong,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleClick("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.buttonText))]
                  )
                : _vm._e(),
              _vm._t("button"),
            ],
            2
          ),
        ],
        2
      ),
      _vm.loading
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }